// AuthSelectors.js
export const isAuthenticated = (state) => {
    const userDetails = state.auth.userDetails;
    return userDetails !== null ;
  };
  